export default "/static/media/icon-youtube.34e7555f.svg";